import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import _map from 'lodash.map'
import SetlistNavContainer from '../../styled/setlist-nav-container'
import MetaSelectContainer from '../../styled/meta-select-container'
import Select from '../../styled/select'

import { event, CATEGORIES, ACTIONS } from '../../utils/analytics-tracker'

export const navClick = () => {
  event(CATEGORIES.SETLIST, ACTIONS.NAVIGATE_SETLIST)
}

const SetlistNavigation = ({ setlist, prevSong, nextSong }) => {
  const navigate = useNavigate()

  const handleKeyDown = (e) => {
    // Check if user is currently typing in an input field, textarea, or interacting with form elements
    const activeElement = document.activeElement
    const isTyping = activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.tagName === 'SELECT' ||
      activeElement.contentEditable === 'true' ||
      activeElement.isContentEditable
    )

    // Don't process navigation shortcuts if user is typing or interacting with form elements
    if (isTyping) {
      return
    }

    const key = e.key
    if ((key === 'f' || key === 'n' || key === 'F' || key === 'N') && nextSong) {
      e.preventDefault()
      selectJumpToSong({ target: { value: nextSong._id } })
    }
    if ((key === 'b' || key === 'p' || key === 'B' || key === 'P') && prevSong) {
      e.preventDefault()
      selectJumpToSong({ target: { value: prevSong._id } })
    }
  }

  useEffect(() => {
    // bind keys
    document.body.addEventListener('keydown', handleKeyDown)
    return () => {
      // unbind keys
      document.body.removeEventListener('keydown', handleKeyDown)
    }
  }, [nextSong, prevSong]) // Add dependencies to ensure we have current song references

  const captureKey = (e) => {
    e.preventDefault()
  }

  const selectJumpToSong = (option) => {
    if (option) {
      navigate(`/setlists/${setlist._id}/song/${option.value}`)
    }
  }
  return (
    <>
      <hr />
      <h2>Set List: {setlist.title}</h2>
      <SetlistNavContainer>
        {prevSong ? <Link onClick={navClick} to={`/setlists/${setlist._id}/song/${prevSong._id}`}>❮ {prevSong.title}</Link> : <div />}
        <MetaSelectContainer>
          <label>Jump to:</label>
          <Select
            onChange={selectJumpToSong}
            onKeyDown={captureKey}
            onKeyUp={captureKey}
            options={_map(setlist.songs, song => ({ value: song._id, label: `${song.title} ${song.artist}` }))}
            placeholder='Select song...'
          />
        </MetaSelectContainer>
        {nextSong ? <Link onClick={navClick} to={`/setlists/${setlist._id}/song/${nextSong._id}`}>{nextSong.title} ❯</Link> : <div />}
      </SetlistNavContainer>
    </>
  )
}

export default SetlistNavigation
